var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"directives"},[_c('div',{staticClass:"distance"},[_vm._v(_vm._s(_vm.$t('approxDistance'))+" "+_vm._s(_vm.distance)+" "+_vm._s(_vm.$tc('distUnit', _vm.distance)))])])}
var staticRenderFns = []

export { render, staticRenderFns }